/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CopyIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M35.376 8.438c.375.374.624.874.624 1.437V24c0 2.25-1.809 4-3.992 4H20.03c-2.245 0-3.992-1.75-4.054-4V8c0-2.187 1.746-4 3.992-4h10.168c.56 0 1.06.25 1.434.625zM33.006 24h-.062V12h-2.932a1.97 1.97 0 0 1-1.996-2l-.063-2.937H19.97a.986.986 0 0 0-.998 1V24c0 .563.436 1 .998 1h12.039c.499 0 .998-.437.998-1m-11.977 8v-2h2.994v2c0 2.25-1.809 4-3.992 4H8.055c-2.246 0-3.993-1.75-3.993-4L4 16c0-2.187 1.809-4 3.992-4h6.05v3.063h-6.05c-.499 0-.998.437-.998 1V32c0 .563.437 1 .998 1h12.04c.498 0 .997-.437.997-1"/>}
        </IconWrapper>);
}
